export default {
    isWhatChimpConnected: (state) => state.conectado,
    whatChimpAuth:        (state) => state.whatChimpAuth,
    whatChimpConnecting:  (state) => state.whatChimpConnecting,
    whatChimpError:       (state) => state.whatChimpError,
    whatsappTemplates: state => state.whatsappTemplates,
    whatsappVariables: state => state.whatsappVariables,
}


// WEBPACK FOOTER //
// ./src/modules/whatChimpApi/getters.js